import { env } from '@/env'

export const isProduction = env.REACT_APP_ENV === 'production'
export const isInternal = env.REACT_APP_ENV === 'internal'

export const suffixBaseURL = {
  booking: '/api/booking/v1',
  myBusiness: '/my-business/api/agency/v1',
  batchReservations: '/my-batches/api/batch/v1',
} as const

const devApiConfig = {
  baseUrl: env.REACT_APP_ENABLE_MSW ? '/' : env.REACT_APP_API_URL_DEV,
}

const prodApiConfig = {
  baseUrl: env.REACT_APP_ENABLE_MSW ? '/' : env.REACT_APP_API_URL,
}

const internalApiConfig = {
  baseUrl: env.REACT_APP_ENABLE_MSW ? '/' : env.REACT_APP_API_URL_PROD_INTERNAL,
}

const apiConfig = isProduction
  ? prodApiConfig
  : isInternal
    ? internalApiConfig
    : devApiConfig

export { apiConfig }
